function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 19,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.057 1.071A5.274 5.274 0 003.788 6.34a5.274 5.274 0 005.269 5.269 5.274 5.274 0 005.268-5.269 5.274 5.274 0 00-5.268-5.268zm0 11.608a6.347 6.347 0 01-6.34-6.34A6.347 6.347 0 019.057 0a6.347 6.347 0 016.34 6.34 6.347 6.347 0 01-6.34 6.34zM18.113 24h-1.065v-3.52c0-2.465-1.586-4.471-3.534-4.471H4.6c-1.949 0-3.534 2.006-3.534 4.472V24H0v-3.52c0-3.053 2.063-5.537 4.599-5.537h8.915c2.536 0 4.6 2.484 4.6 5.538V24z",
    fill: props.color
  }));
}

export default SvgProfile;